import { useTheme } from "@mui/material/styles";
import { IThemeColorShades } from "src/theme-mui/tokens/colors";

type IAvatarPaletteKey = "gray" | "green" | "sky" | "teal" | "lilac" | "orange" | "blush" | "blue";

const AVATAR_COLOR_TOKENS: Array<[IAvatarPaletteKey, keyof IThemeColorShades]> = [
    ["gray", 800],
    ["green", 600],
    ["sky", 600],
    ["teal", 600],
    ["lilac", 600],
    ["orange", 600],
    ["blush", 600],
    ["blue", 600],
];

export const useAvatarColor = (id: string) => {
    const theme = useTheme();
    const unicodeSum = id.split("").reduce((acc, curr) => acc + (curr.codePointAt(0) ?? 0), 0);
    const [paletteKey, shade] = AVATAR_COLOR_TOKENS[unicodeSum % AVATAR_COLOR_TOKENS.length];

    return theme.palette[paletteKey][shade];
};
